export const placeBetInitialState = {
    placeBetId: null,
    betBoxBgColor: "#ffffff"
};
